var rich_content_viewer_default = {
  "fontElementMap": "KuDxV",
  "wrapper": "_1kzvc",
  "pluginContainerMobile": "IXGOE",
  "viewer": "RACDS",
  "android": "_6uWFJ",
  "rootedTraversedContent": "_-5d18",
  "atomic": "saAY8",
  "toolbar": "MV4gm",
  "block": "uArYt"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
